<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button size="small" class="btn" type="primary" v-if="show.zxsb" @click="handleCreate">执行上报</el-button>
        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item prop="rwlx" :label="lable.rwlx">
            <el-select v-model="deviceInfo.rwlx" style="width:100%" placeholder="请选择" clearable>
              <el-option v-for="item in optionTasks" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发起日期">
            <el-date-picker v-model="deviceInfo.date" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="getDeviceinfoClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="deviceData" tooltip-effect="dark"
          style="width: 100%;text-align:center" stripe>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column :label="lable.index" type="index" show-overflow-tooltip >
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="任务单号"> </el-table-column>
          <el-table-column prop="rwbt" sortable :label="lable.rwbt" width="120PX">
          </el-table-column>
          <el-table-column prop="rwlx" sortable :label="lable.rwlx" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.rwlx == 1">维保</span>
              <span v-else-if="scope.row.rwlx == 2">检定</span>
              <span v-else-if="scope.row.rwlx == 3">核查</span>
              <span v-else-if="scope.row.rwlx == 4">其他</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="zxdw" sortable label="执行单位" show-overflow-tooltip>
          </el-table-column> -->
          <el-table-column prop="jhwcsj" sortable :label="lable.jhwcsj" show-overflow-tooltip>
          </el-table-column>
          <!-- <el-table-column sortable prop="zxsj" :label="lable.zxsj" show-overflow-tooltip>
          </el-table-column> -->
          <el-table-column sortable prop="xfsj" :label="lable.xfsj" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="wcrq" :label="lable.wcrq" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="zxr" :label="lable.zxr" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" sortable :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == 0" style="color:#4095E5">待执行</span>
              <span v-else-if="scope.row.statue == 1" style="color:cadetblue">待确认</span>
              <span v-else-if="scope.row.statue == 2" style="color:gray">待评价</span>
              <span v-else style="color:blueviolet">评价完成</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="deviceData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
    <!---------------------------------------------------------------------------------------------执行上报弹框--------------------------------------------------------------------->
    <el-dialog width="30%" title="执行上报" :visible.sync="innerVisible" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form ref="form" :model="form" label-width="110px">
        <el-form-item label="执行情况说明">
          <el-input v-model="form.zxqk" type="textarea" :rows="2" placeholder="执行情况说明"></el-input>
        </el-form-item>
        <el-form-item :label="lable.zxsj">
          <el-date-picker v-model="form.date" type="daterange" style="width:100%" value-format="yyyy-MM-dd"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit" v-preventReClick>执行</el-button>
          <el-button @click="innerVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { findByZxr, implementTask, findAllUser, findByModule } from "../../api/api";
export default {
  name: "TaskExecution",
  data() {
    return {
      deviceInfo: {
        rwlx: "",
        content: "",
        date: ""
      },
      lable: {},
      innerVisible: false,
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      // optionUsers: [],
      multipleTable: [],
      deviceData: [],
      form: {},
      show: {
        zxsb: false
      },
      optionTasks: [
        {
          id: 1,
          name: "维保"
        },
        {
          id: 2,
          name: "检定"
        },
        {
          id: 3,
          name: "核查"
        },
        {
          id: 4,
          name: "其他"
        }
      ],
    };
  },
  mounted() {
    this.findLable();
    this.getDeviceinfo();
    // this.selectUser();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "117") {
        this.show.zxsb = true;
      }
    })
  },
  methods: {
    findLable() {
      findByModule("计划任务").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },

    //选择信息
    handleCreate() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.$message.error("只能选择一条信息"); // .....失败信息
      } else if (currentSelect.length == 1) {
        this.form = {};
        this.form.taskId = currentSelect[0].id;
        this.innerVisible = true;
      } else {
        this.$message.error("请选择执行的任务"); // .....失败信息
      }
    },
    //查找设备信息
    getDeviceinfo() {
      var userinfo = JSON.parse(localStorage.getItem("user"))

      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        state: 0,
        rwlx: this.deviceInfo.rwlx,
        userId: userinfo.userId
      };
      findByZxr(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.deviceData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = (data == null ? 0 : data.length);
          // debugger
        }
      });
    },
    getDeviceinfoClick(){
      this.pageIndex=1
      this.getDeviceinfo();
    },
    onSubmit() {
      if (this.form.date != null) {
        this.form.zxsj = this.form.date[0];
        this.form.zxjs = this.form.date[1];
        var userinfo = JSON.parse(localStorage.getItem("user"))
        this.form.userId = userinfo.userId
        implementTask(this.form).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.innerVisible = false;
            this.$message({
              message: "执行成功",
              type: "success"
            });
            this.getDeviceinfo();
            // debugger
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      } else {
        this.$message.warning("请选择时间")
      }

    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.deviceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.deviceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    }
  }
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/task/TaskExecution.vue